import * as types from '../constants/ActionTypes';

export const setStudySearchConfig = (payload) => ({
  type: types.SET_STUDY_SEARCH_CONFIG,
  payload,
});

// const setStudiesList = (payload) => ({
//   type: types.SET_STUDIES_LIST,
//   payload,
// });

// const setFilters = (payload) => ({
//   type: types.SET_FILTERS,
//   payload,
// });

const setSearch = (payload) => ({
  type: types.SET_SEARCH,
  payload,
});

const setCurrentPage = (payload) => ({
  type: types.SET_CURRENT_PAGE,
  payload,
});

const setRowsPerPage = (payload) => ({
  type: types.SET_ROWS_PER_PAGE,
  payload,
});

const setNextPageDisabled = (payload) => ({
  type: types.SET_NEXT_PAGE_DISABLED,
  payload,
});

const setSelectedPacsIndex = (payload) => ({
  type: types.SET_SELECTED_PACS_INDEX,
  payload,
});

// const setTotalStudies = (payload) => ({
//   type: types.SET_TOTAL_STUDIES,
//   payload,
// });

export default {
  // setStudiesList,
  setCurrentPage,
  setRowsPerPage,
  setNextPageDisabled,
  setSelectedPacsIndex,
  // setTotalStudies,
  // setFilters,
  setSearch,
};
